import React from 'react';
import { Col, Row } from 'react-bootstrap';

const ShowPagoInfo = (props) => {
  const { data } = props;

  return (
    <Row className="mt-3">
      <Col>
        <strong>Pagos realizados: </strong> {data.Factoraje?.Pagos}
        <br />
        <strong>Monto Pagado: </strong> {data.Factoraje?.ImportePagado}
        <br />
        <strong>Monto Pendiente: </strong> {data.Factoraje?.ImporteSaldoInsoluto}
        <br />
      </Col>
      <Col>
        <strong>Serie: </strong> {data.Serie}
        <br />
        <strong>Folio: </strong> {data.Folio}
        <br />
        <strong>Moneda: </strong> {data.Moneda}
        <br />
        <strong>Tipo de Cambio: </strong> {data.TipoCambio}
        <br />
      </Col>
    </Row>
  );
};

export default ShowPagoInfo;
